import { breakpoints } from '../config/breakpoints';

const mediaQueries = {};
const reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

function updateImageAlt(image, matches) {
  const parent = image.closest('picture');

  if (!parent || parent.querySelectorAll('source').length < 2) {
    return;
  }

  const desktop = parent.querySelector('source[data-alt-desktop]');
  const mobile = parent.querySelector('source[data-alt-mobile]');

  if (!desktop || !mobile) {
    return;
  }

  /* eslint-disable-next-line no-param-reassign */
  image.alt = matches ? mobile.dataset.altMobile : desktop.dataset.altDesktop;
}

function updateVideoPoster(video, matches) {
  if (matches && 'posterMobile' in video.dataset) {
    /* eslint-disable-next-line no-param-reassign */
    video.poster = video.dataset.posterMobile;
  } else if ('posterDesktop' in video.dataset) {
    /* eslint-disable-next-line no-param-reassign */
    video.poster = video.dataset.posterDesktop;
  }

  if ('fallback' in video.dataset) {
    video.nextElementSibling.remove();
    const fallbackEl = video.nextElementSibling;
    video.removeAttribute('data-fallback');

    if (fallbackEl) {
      if (video.readyState >= 2) {
        fallbackEl.remove();
      } else {
        video.addEventListener('loadeddata', () => {
          fallbackEl.remove();
        }, { once: true });
      }
    }
  }
}

function updateReducedMotionVideo(video, prefersReducedMotion) {
  const hasAutoplay = video.autoplay || video.hasAttribute('autoplay');
  const autoplayWasStored = video.dataset.autoplayOriginal === 'true';

  if (prefersReducedMotion) {
    if (hasAutoplay) {
      /* eslint-disable-next-line no-param-reassign */
      video.dataset.autoplayOriginal = 'true';
    }

    if (hasAutoplay || autoplayWasStored) {
      video.removeAttribute('autoplay');
      video.pause();
      video.load();
    }

    return;
  }

  if (autoplayWasStored) {
    video.setAttribute('autoplay', 'autoplay');
    /* eslint-disable-next-line no-param-reassign */
    video.dataset.autoplayOriginal = 'false';
  }
}

/**
 * Initialize the header component.
 */
export default function () {
  function init() {
    const images = document.querySelectorAll('picture img');
    const videos = document.querySelectorAll('video[data-poster-desktop]');

    function processMedia(media, key) {
      let breakpoint = breakpoints.md;

      if ('breakpoint' in media.dataset) {
        breakpoint = media.dataset.breakpoint;
      }

      if (!(breakpoint in mediaQueries)) {
        mediaQueries[breakpoint.toString()] = {
          images: [],
          videos: [],
        };
      }

      mediaQueries[breakpoint.toString()][key].push(media);
    }

    images.forEach((image) => {
      processMedia(image, 'images');
    });

    videos.forEach((video) => {
      processMedia(video, 'videos');
    });

    Object.keys(mediaQueries).forEach((breakpoint) => {
      const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
      const {
        images: mqImages,
        videos: mqVideos,
      } = mediaQueries[breakpoint];

      function updateMedia(matches) {
        mqImages.forEach((image) => {
          updateImageAlt(image, matches);
        });

        mqVideos.forEach((video) => {
          updateVideoPoster(video, matches);
        });
      }

      mq.addEventListener('change', (event) => {
        updateMedia(event.matches);
      });

      updateMedia(mq.matches);
    });

    const autoplayVideos = document.querySelectorAll('video[autoplay]');

    function updateReducedMotionMedia(matches) {
      autoplayVideos.forEach((video) => {
        updateReducedMotionVideo(video, matches);
      });
    }

    reducedMotionMQ.addEventListener('change', (event) => {
      updateReducedMotionMedia(event.matches);
    });

    updateReducedMotionMedia(reducedMotionMQ.matches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
